import * as React from "react";
import { ViewMe, UpdateCustomer } from "@njoy/controller";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { PersonalDetailView, defaultCustomerFormValues } from "./ui/PersonalDetailView";
import Loader from "../../../components/loader/Loader";

import ToastMessage from "../../../hooks/useToast";
// import { extractError } from "../../../utils/extractError";
 
export class PersonalDetailConnector extends React.PureComponent {
    private timeoutId: ReturnType<typeof setTimeout> | null = null;

  componentWillUnmount() {
    // Clean up timeout if component unmounts before it fires
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }
  render() {
    return (
      <ViewMe>
        {({ match, loading }) => {
          if (loading) {
            return <Loader center text="Loading..." noLeftMargin />;
          }
 
          if (!match) {
            return <Loader center text="No user data found..." noLeftMargin />;
          }
 
          const customer = match.customer;
          return (
            <UpdateCustomer>
              {({ updateCustomer }:{updateCustomer:any}) => (
                <>
                  <ToastContainer />
                
                  <PersonalDetailView
                    initialValues={{
                      ...defaultCustomerFormValues,
                      ...customer,
                    }}
                    
                    submit={async (values: any, { setErrors, setSubmitting, resetForm, ...formikHelpers }: any) => {
                      setSubmitting(true);
                      try {
                        const { __typename: __, ...newValues } = values;

                        const result = await updateCustomer({
                          input: {
                            username: newValues.username,
                            address: newValues.address,
                            // communityId: newValues.communityId,
                            gender: newValues.gender,
                            dob: newValues.dob
                          },
                        });

                        setSubmitting(false);
                        if (!result.errors || Object.keys(result.errors).length === 0) {
                          ToastMessage("success", result.message || "Update successful.");

                          this.timeoutId = setTimeout(() => {
                            window.location.reload();
                            if (
                              formikHelpers.props &&
                              typeof formikHelpers.props.onFinish === "function"
                            ) {
                              formikHelpers.props.onFinish();
                            }
                          }, 2000);
                          
                          return;
                        }

                        // ToastMessage("error", extractError(result.errors));
                        setErrors && setErrors(result.errors);
                      } catch (err) {
                        setSubmitting(false);
                        ToastMessage("error", "Something went wrong. Please try again.");
                      }
                    }}
                  />
                </>
              )}
            </UpdateCustomer>
          );
        }}
      </ViewMe>
    );
  }
}